var _ellipse, _ellipse2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBuyDonate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0345,
    cy: 10.8565,
    rx: 9.21055,
    ry: 9.25929,
    fill: "#FF900F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.7188,
    cy: 10.1159,
    rx: 7.73687,
    ry: 7.40743,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7871 9.02323H12.1528V6.08618L12.1538 5.89552L12.1557 5.85411C12.1638 5.80446 12.1873 5.75862 12.2227 5.72304C12.2581 5.68746 12.3036 5.66392 12.353 5.65574C12.4296 5.65365 12.5063 5.65269 12.5829 5.65285H14.7871C15.2316 5.65285 15.658 5.8304 15.9724 6.14643C16.2868 6.46246 16.4634 6.8911 16.4634 7.33804C16.4634 7.78498 16.2868 8.21362 15.9724 8.52965C15.658 8.84568 15.2316 9.02323 14.7871 9.02323Z",
    fill: "#F9B25F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9292 9.74538C22.9292 15.0638 18.6407 19.375 13.3502 19.375C8.05975 19.375 3.77124 15.0638 3.77124 9.74538C3.77124 4.42692 8.05975 0.115723 13.3502 0.115723C18.6407 0.115723 22.9292 4.42692 22.9292 9.74538ZM9.7581 11.6713C9.7581 11.4798 9.83379 11.2961 9.96852 11.1606C10.1033 11.0252 10.286 10.9491 10.4765 10.9491H10.716V10.4676H10.4765C10.286 10.4676 10.1033 10.3915 9.96852 10.2561C9.83379 10.1206 9.7581 9.93693 9.7581 9.74538C9.7581 9.55384 9.83379 9.37014 9.96852 9.23469C10.1033 9.09925 10.286 9.02316 10.4765 9.02316H10.716V6.04952C10.716 5.90893 10.716 5.76352 10.7371 5.62967C10.7925 5.27839 10.9571 4.95376 11.2073 4.70226C11.4575 4.45075 11.7804 4.28527 12.1299 4.22951C12.263 4.20833 12.4076 4.20833 12.5465 4.20833H14.7871C15.6127 4.20833 16.4046 4.53806 16.9884 5.12498C17.5722 5.7119 17.9002 6.50794 17.9002 7.33797C17.9002 8.168 17.5722 8.96404 16.9884 9.55096C16.4046 10.1379 15.6127 10.4676 14.7871 10.4676H12.1528V10.9491H13.3502C13.5408 10.9491 13.7235 11.0252 13.8582 11.1606C13.9929 11.2961 14.0686 11.4798 14.0686 11.6713C14.0686 11.8629 13.9929 12.0466 13.8582 12.182C13.7235 12.3174 13.5408 12.3935 13.3502 12.3935H12.1528V14.5602C12.1528 14.7518 12.0772 14.9355 11.9424 15.0709C11.8077 15.2063 11.625 15.2824 11.4344 15.2824C11.2439 15.2824 11.0612 15.2063 10.9264 15.0709C10.7917 14.9355 10.716 14.7518 10.716 14.5602V12.3935H10.4765C10.286 12.3935 10.1033 12.3174 9.96852 12.182C9.83379 12.0466 9.7581 11.8629 9.7581 11.6713Z",
    fill: "#F9B25F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBuyDonate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/buy_donate.6a714050.svg";
export { ForwardRef as ReactComponent };